export default {"src":"/_next/static/media/404-error.32345131.svg","height":460,"width":567};